import React, { useState } from "react";
import { QRCodeSVG } from "qrcode.react";
import { MessageCircle, X } from "lucide-react";

export function TelegramBanner() {
  const [showQR, setShowQR] = useState(false);
  const botLink = "https://t.me/QuickDashBot";

  return (
    <div className="fixed bottom-4 right-4 z-50">
      <button
        onClick={() => setShowQR(!showQR)}
        className="bg-[#0088cc] text-white p-3 rounded-full shadow-lg hover:bg-[#0077b3] transition flex items-center gap-2"
      >
        <MessageCircle size={20} />
        <span className="text-sm font-medium pr-1">Order via Telegram</span>
      </button>

      {showQR && (
        <div className="absolute bottom-14 right-0 bg-white p-4 rounded-2xl shadow-xl border border-slate-200 w-64">
          <div className="flex justify-between items-center mb-3">
            <h4 className="font-bold text-slate-800">Quick Order</h4>
            <button onClick={() => setShowQR(false)} className="text-slate-400">
              <X size={16} />
            </button>
          </div>

          <div className="flex justify-center">
            <QRCodeSVG value={botLink} size={200} level="H" />
          </div>

          <p className="text-xs text-center text-slate-500 mt-3">
            Scan with your phone camera
          </p>

          <a
            href={botLink}
            target="_blank"
            rel="noopener noreferrer"
            className="block mt-3 text-center bg-[#0088cc] text-white py-2 rounded-lg text-sm hover:bg-[#0077b3]"
          >
            Open Telegram
          </a>
        </div>
      )}
    </div>
  );
}
